var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-menu" },
    [
      !_vm.isLoggedIn && !_vm.isSignInDisabled
        ? _c(
            "a",
            { staticClass: "sign-in", on: { click: _vm.handleMenuClick } },
            [_c("user-icon"), _vm._v(" "), _c("span", [_vm._v("Sign In")])],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn
        ? _c(
            "a",
            {
              staticClass: "account-control",
              on: { click: _vm.handleMenuClick },
            },
            [
              _c("account-icon"),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.user.name))]),
              _vm._v(" "),
              _c("chevron-up"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAccountDropdown
        ? _c("account-dropdown", {
            directives: [
              {
                name: "on-clickaway",
                rawName: "v-on-clickaway",
                value: _vm.hideDropdown,
                expression: "hideDropdown",
              },
            ],
            on: { hide: _vm.hideDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }